
<!--<div class="container">-->
<div class="background-div">
  <div class="container">
    <div class="main-div">
      <div class="left-pane">
        <h1 i18n>Join us now</h1>

        <ul class="progress-bar">
          <li [ngClass]="(signupService.currentStep$ | async) === signupService.Step.BASIC_INFO ? 'stop' : ''">
          <li [ngClass]="(signupService.currentStep$ | async) === signupService.Step.EMAIL_CONFIRMATION ? 'stop' : ''">
          <li [ngClass]="(signupService.currentStep$ | async) === signupService.Step.MERCHANT_LOGIN ? 'stop' : ''">
          <li [ngClass]="(signupService.currentStep$ | async) === signupService.Step.MERCHANT_MORE_INFO ? 'stop' : ''">
          <li [ngClass]="(signupService.currentStep$ | async) === signupService.Step.MERCHANT_CONTACT_INFO ? 'stop' : ''">
          <li [ngClass]="(signupService.currentStep$ | async) === signupService.Step.REVIEWING_ACCOUNT ? 'stop' : ''">
        </ul>

        <div>
          <router-outlet></router-outlet>
        </div>

        <div class="buttons-div">
          <button class="button-secondary button-with-image" (click)="signupService.backButtonClicked()" [disabled]="signupService.disableBackButton" i18n><div class="i-image-to-flip"><i class="bi bi-arrow-left "></i></div>Back</button>
          <div>
            <button type="submit" class="button-primary button-with-image" (click)="signupService.nextButtonClicked()" [disabled]="signupService.disableNextButton" *ngIf="!signupService.loadingNextButton" i18n>Next<div class="i-image-to-flip"><i class="bi bi-arrow-right"></i></div></button>
            <button class="button-primary" type="button" disabled *ngIf="signupService.loadingNextButton">
              <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
              <span class="visually-hidden" role="status">Loading...</span>
            </button>
          </div>
        </div>
      </div>
      <div class="right-pane"></div>
    </div>
  </div>
</div>
<!--</div>-->
